import { render } from "./NavMenu.vue?vue&type=template&id=48e5b694&scoped=true"
import script from "./NavMenu.vue?vue&type=script&lang=js"
export * from "./NavMenu.vue?vue&type=script&lang=js"

import "./NavMenu.vue?vue&type=style&index=0&id=48e5b694&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/nce_go/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e5b694"]])

export default __exports__